import type { ModuleDef, Role } from '@/shared/types'

export const ROLES: Role[] = [
  {
    level: 'quan-chung',
    label: 'Cấp Quân chủng',
    description: 'Sở chỉ huy Quân chủng — quản lý, điều hành, tổng hợp toàn quân',
  },
  {
    level: 'su-doan',
    label: 'Cấp Sư đoàn',
    description: 'Sở chỉ huy Sư đoàn — điều hành cấp khu vực',
  },
  {
    level: 'trung-doan',
    label: 'Cấp Trung đoàn',
    description: 'Sở chỉ huy Trung đoàn — chỉ huy trực tiếp đơn vị tác chiến',
  },
  {
    level: 'tieu-doan',
    label: 'Cấp Tiểu đoàn',
    description: 'Tiểu đoàn — đơn vị tác chiến cấp trung gian',
  },
  {
    level: 'dai-doi',
    label: 'Cấp Đại đội',
    description: 'Đại đội — đơn vị tác chiến trực tiếp, nhập liệu nguồn',
  },
]

export const MODULES: ModuleDef[] = [
  {
    key: 'tac-chien',
    path: '/tac-chien',
    title: 'Tác chiến — Huấn luyện — An toàn bay',
    shortTitle: 'Tác chiến',
    description:
      'Quản lý hoạt động tác chiến, trực ban chiến đấu, huấn luyện bay/dù, tìm kiếm cứu nạn và an toàn bay quân sự.',
    icon: 'RadarChartOutlined',
    color: '#ef4444',
    phase: 2,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'ke-hoach-bay',
    path: '/ke-hoach-bay',
    title: 'Kế hoạch bay — Điều hành bay',
    shortTitle: 'Kế hoạch bay',
    description:
      'Lập, phê duyệt, phát hành kế hoạch bay nhiều cấp; quản lý phi công, máy bay, không vực, đường bay; hiệp đồng dân dụng.',
    icon: 'SendOutlined',
    color: '#1e6091',
    phase: 1,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'van-tai',
    path: '/van-tai',
    title: 'Vận tải hàng không quân sự',
    shortTitle: 'Vận tải',
    description:
      'Lập kế hoạch vận chuyển, quản lý hành khách, hàng hóa; hiệp đồng dân dụng; tích hợp camera giám sát.',
    icon: 'CarOutlined',
    color: '#10b981',
    phase: 2,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'bao-dong',
    path: '/bao-dong',
    title: 'Hệ thống Báo động (nâng cấp)',
    shortTitle: 'Báo động',
    description:
      'Bản đồ tactical realtime, hiển thị mục tiêu, cảnh báo phòng không — nâng cấp hệ thống đã triển khai 2018 tại 53 SCH.',
    icon: 'AlertOutlined',
    color: '#f59e0b',
    phase: 1,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'hau-can',
    path: '/hau-can',
    title: 'Hậu cần — Vũ khí',
    shortTitle: 'Hậu cần',
    description:
      'Quản lý kho vũ khí, đạn dược, nhiên liệu hàng không, vật tư phụ tùng và quân trang phục vụ tác chiến và huấn luyện.',
    icon: 'ContainerOutlined',
    color: '#dc2626',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'y-te',
    path: '/y-te',
    title: 'Y tế — Sức khỏe phi công',
    shortTitle: 'Y tế',
    description:
      'Hồ sơ y tế phi công, khám sức khỏe định kỳ, đánh giá tâm lý, mệt mỏi, giấy phép bay y tế.',
    icon: 'HeartOutlined',
    color: '#ec4899',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'workflow',
    path: '/workflow',
    title: 'Workflow Engine — BPMN',
    shortTitle: 'Workflow',
    description: 'BPMN designer, inbox, instance map, SLA tracking, escalation cho mọi quy trình phê duyệt nhiều cấp.',
    icon: 'PartitionOutlined',
    color: '#7c3aed',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'notif',
    path: '/notif',
    title: 'Notification Center',
    shortTitle: 'Thông báo',
    description: 'Đa kênh (web/email/SMS/push/loa), broadcast, escalation, monitor 53 SCH.',
    icon: 'NotificationOutlined',
    color: '#f59e0b',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'dao-tao',
    path: '/dao-tao',
    title: 'Đào tạo chuyên sâu',
    shortTitle: 'Đào tạo',
    description:
      'Quản lý chương trình HL, khóa học, học viên, giảng viên, lịch huấn luyện, mô phỏng, đánh giá năng lực và chứng chỉ.',
    icon: 'ReadOutlined',
    color: '#a855f7',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'dan-duong',
    path: '/dan-duong',
    title: 'Dẫn đường bay',
    shortTitle: 'Dẫn đường',
    description:
      'Tính toán đường bay, phương án vũ khí, hiệu suất chiến đấu; hỗ trợ ra quyết định tại Sở chỉ huy.',
    icon: 'CompassOutlined',
    color: '#8b5cf6',
    phase: 2,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'khi-tuong',
    path: '/khi-tuong',
    title: 'Khí tượng',
    shortTitle: 'Khí tượng',
    description:
      'Bản đồ khí tượng đa lớp (gió, mưa, nhiệt độ, áp suất), trạm quan trắc, vệ tinh và tích hợp khí tượng quốc gia.',
    icon: 'CloudOutlined',
    color: '#06b6d4',
    phase: 2,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'gis',
    path: '/gis',
    title: 'GIS Platform',
    shortTitle: 'GIS',
    description: 'Bản đồ 2D/3D, layer manager, ký hiệu quân sự, phân tích không gian, tích hợp BĐ BQP.',
    icon: 'GlobalOutlined',
    color: '#0ea5e9',
    phase: 3,
    status: 'ready',
    group: 'business',
  },
  {
    key: 'innovation',
    path: '/innovation',
    title: 'Innovation Lab — Twin · Wargame · AR · Predictive',
    shortTitle: '✨ Innovation',
    description: 'Wow features: Digital Twin 3D · War-game simulation · Predictive maintenance AI · AR overlay.',
    icon: 'BulbOutlined',
    color: '#a855f7',
    phase: 4,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'dashboard-cmd',
    path: '/dashboard-cmd',
    title: 'Dashboard Chỉ huy (BI)',
    shortTitle: 'BI Chỉ huy',
    description: 'Dashboard riêng cho lãnh đạo các cấp + Wall display 32:9 + mobile + cá nhân hoá.',
    icon: 'DashboardOutlined',
    color: '#0891b2',
    phase: 4,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'user-admin',
    path: '/user-admin',
    title: 'Quản trị Người dùng',
    shortTitle: 'User Admin',
    description: 'Onboarding/offboarding, RBAC bulk, access requests, sync HR BQP.',
    icon: 'TeamOutlined',
    color: '#a855f7',
    phase: 3,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'bao-cao',
    path: '/bao-cao',
    title: 'Trung tâm Báo cáo',
    shortTitle: 'Báo cáo',
    description:
      'Trung tâm báo cáo định kỳ tất cả phân hệ — KPI theo kỳ, trend, phân bổ, mẫu báo cáo, phân quyền truy cập tập trung.',
    icon: 'FileTextOutlined',
    color: '#0ea5e9',
    phase: 3,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'danh-muc',
    path: '/danh-muc',
    title: 'Trung tâm Danh mục',
    shortTitle: 'Danh mục',
    description:
      'Master data tập trung — phi công, máy bay, không vực, đường bay, sân bay, hiệp đồng dân dụng, khí tài. Phân quyền sửa đổi RBAC.',
    icon: 'DatabaseOutlined',
    color: '#7c3aed',
    phase: 3,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'ai',
    path: '/ai',
    title: 'AI Hub — Điều phối & Giám sát AI',
    shortTitle: 'AI Hub',
    description:
      'Trung tâm AI tập trung — model registry, audit log, RBAC theo cấp, edge nodes giám sát hạ tầng AI 5 cấp SCH.',
    icon: 'RobotOutlined',
    color: '#a855f7',
    phase: 4,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'help',
    path: '/help',
    title: 'Trợ giúp',
    shortTitle: 'Trợ giúp',
    description: 'Hướng dẫn sử dụng, tour onboarding, tài liệu, FAQ và kênh hỗ trợ.',
    icon: 'QuestionCircleOutlined',
    color: '#0ea5e9',
    phase: 3,
    status: 'ready',
    group: 'admin',
  },
  {
    key: 'admin',
    path: '/admin',
    title: 'Quản trị hệ thống',
    shortTitle: 'Quản trị',
    description:
      'Đồng bộ CSDL Bộ Quốc phòng, master data dùng chung, RBAC, audit log, cấu hình hệ thống.',
    icon: 'SettingOutlined',
    color: '#6b7280',
    phase: 3,
    status: 'ready',
    group: 'admin',
  },
]

export const BUSINESS_MODULES = MODULES.filter((m) => m.group === 'business')
export const ADMIN_MODULES = MODULES.filter((m) => m.group === 'admin')
